export enum CompletionStatus {
  EMPTY = 0,
  PARTIAL = 1,
  COMPLETED = 2
}
